/** @jsx jsx */

import { jsx, css } from '@emotion/react';
import { N30 } from '@atlaskit/theme/colors';
const ExtensionFrame = props => {
  const containerCSS = css`
    border: 1px solid ${`var(--ds-border, ${N30})`};
    min-height: 100px;
  `;
  return jsx("div", {
    css: containerCSS,
    className: "extension-frame",
    "data-extension-frame": "true",
    style: {
      flexBasis: `100%`
    }
  }, props.children);
};
export default ExtensionFrame;